// extracted by mini-css-extract-plugin
module.exports = {"authNavigation":"vetAuthNavigation_authNavigation__2g9Fo","authNavigation__link":"vetAuthNavigation_authNavigation__link__3v6Yr"};